var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 2.375C6.99219 2.375 5.625 3.78125 5.625 5.5V8H11.875V5.5C11.875 3.78125 10.4688 2.375 8.75 2.375ZM3.75 5.5C3.75 2.76562 5.97656 0.5 8.75 0.5C11.4844 0.5 13.75 2.76562 13.75 5.5V8H15C16.3672 8 17.5 9.13281 17.5 10.5V18C17.5 19.4062 16.3672 20.5 15 20.5H2.5C1.09375 20.5 0 19.4062 0 18V10.5C0 9.13281 1.09375 8 2.5 8H3.75V5.5ZM2.5 9.875C2.14844 9.875 1.875 10.1875 1.875 10.5V18C1.875 18.3516 2.14844 18.625 2.5 18.625H15C15.3125 18.625 15.625 18.3516 15.625 18V10.5C15.625 10.1875 15.3125 9.875 15 9.875H2.5ZM9.6875 13V15.5C9.6875 16.0469 9.25781 16.4375 8.75 16.4375C8.20312 16.4375 7.8125 16.0469 7.8125 15.5V13C7.8125 12.4922 8.20312 12.0625 8.75 12.0625C9.25781 12.0625 9.6875 12.4922 9.6875 13Z",
    fill: "#0CBC48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.34cab1b0206a34d65a006a627490e3f6.svg";
export { ForwardRef as ReactComponent };